export const SIGNALR_CONNECTION_SUCCESS = 'SIGNALR_CONNECTION_SUCCESS';
export const SIGNALR_CONNECTION_FAILED = 'SIGNALR_CONNECTION_FAILED';
export const SIGNALR_CONNECTION_STARTED = 'SIGNALR_CONNECTION_STARTED';
export const GET_NOTIFICATIONS_FROM_STORE_STARTED =
  'GET_NOTIFICATIONS_FROM_STORE_STARTED';
export const GET_NOTIFICATIONS_FROM_STORE_SUCCESS =
  'GET_NOTIFICATIONS_FROM_STORE_SUCCESS';
export const GET_NOTIFICATIONS_FROM_STORE_FAILED =
  'GET_NOTIFICATIONS_FROM_STORE_FAILED';
export const GET_SYSTEM_MAINTENANCE_STARTED = 'GET_SYSTEM_MAINTENANCE_STARTED';
export const GET_SYSTEM_MAINTENANCE_SUCCESS = 'GET_SYSTEM_MAINTENANCE_SUCCESS';
export const GET_SYSTEM_MAINTENANCE_FAILED = 'GET_SYSTEM_MAINTENANCE_FAILED';
export const GET_SYSTEM_MAINTENANCE_SIGNALR_SUCCESS =
  'GET_SYSTEM_MAINTENANCE_SIGNALR_SUCCESS';
export const SET_RBAC_CONFIGURATION_SUCCESS = 'SET_RBAC_CONFIGURATION_SUCCESS';
export const SET_KF_APP_COMMON_DATA_SUCCESS = 'SET_KF_APP_COMMON_DATA_SUCCESS';
export const HEIRING_MANAGER_REPORT = 'HiringManager-configurable';
export const KF4D_INTERVIEW_GUIDE = 'InterviewGuide-configurable';
